/**
 * Relative (endless) encoders send a CC whose value is a signed step, in one of four spellings. Magnitudes above 1 are the encoder's own acceleration and are kept.
 *
 * | encoding  | +1  | −1  | aka                                      |
 * |-----------|-----|-----|------------------------------------------|
 * | `twos`    | 1   | 127 | two's complement, Ableton "Relative (2's Comp.)" |
 * | `offset`  | 65  | 63  | binary offset, Ableton "Relative (Bin Offset)"   |
 * | `signed`  | 1   | 65  | sign bit set = negative, "Signed Bit"     |
 * | `signed2` | 65  | 1   | sign bit set = positive, "Signed Bit 2"   |
 */
export const ENCODINGS = ['twos', 'offset', 'signed', 'signed2']

/** The signed step a 7-bit value spells; 0 for a value that moves nothing. */
export const decodeRelative = (raw, encoding = 'twos') => {
	const v = raw & 0x7f
	switch (encoding) {
		case 'offset':
			return v - 64
		case 'signed':
			return v & 0x40 ? -(v & 0x3f) : v & 0x3f
		case 'signed2':
			return v & 0x40 ? v & 0x3f : -(v & 0x3f)
		default:
			return v & 0x40 ? v - 128 : v
	}
}
